/* Optional keyboard-focus version. Does not change layout or overflow. */
(function () {
  'use strict';
  var ring, target, observed, resizeObserver, frame, animationFrame;
  var keyboard = false;
  var appearance;
  var animationUntil = 0;
  var forcedColors = window.matchMedia('(forced-colors: active)');

  function clear() {
    if (target) target.removeAttribute('data-pm-focus-overlay');
    target = null;
    if (ring) {
      if (ring.hasAttribute('popover') && ring.matches(':popover-open')) ring.hidePopover();
      ring.hidden = true;
    }
    if (resizeObserver) resizeObserver.disconnect();
    observed = null;
  }

  function bounds(element) {
    // Stretched links cover their entire positioned card, including its image.
    var box = element.classList.contains('stretched-link') ?
      element.closest('.card, .product-card, .featured_item_card') || element : element;
    var rect = box.getBoundingClientRect();
    var result = {left: rect.left, top: rect.top, right: rect.right, bottom: rect.bottom};
    // Follow the visible part if the user manually scrolls an oversized item.
    for (var ancestor = box.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
      var style = window.getComputedStyle(ancestor);
      var clipX = /hidden|clip|auto|scroll/.test(style.overflowX);
      var clipY = /hidden|clip|auto|scroll/.test(style.overflowY);
      if (!clipX && !clipY) continue;
      var clip = ancestor.getBoundingClientRect();
      if (clipX) {
        result.left = Math.max(result.left, clip.left + ancestor.clientLeft);
        result.right = Math.min(result.right, clip.left + ancestor.clientLeft + ancestor.clientWidth);
      }
      if (clipY) {
        result.top = Math.max(result.top, clip.top + ancestor.clientTop);
        result.bottom = Math.min(result.bottom, clip.top + ancestor.clientTop + ancestor.clientHeight);
      }
    }
    return result;
  }

  function paint() {
    frame = null;
    var active = document.activeElement;
    if (!active || active === document.body || active.tabIndex < 0 ||
        !active.matches('a, button, input, select, textarea, summary, [tabindex]') ||
        (!keyboard && !active.matches(':focus-visible')) || active.closest('[hidden], [inert]')) {
      clear(); return;
    }
    if (target !== active) {
      clear();
      var style = window.getComputedStyle(active);
      appearance = {
        color: style.outlineStyle !== 'none' && parseFloat(style.outlineWidth) > 0 ? style.outlineColor : '#005fcc',
        width: Math.max(2, parseFloat(style.outlineWidth) || 0),
        style: /dashed|dotted|double/.test(style.outlineStyle) ? style.outlineStyle : 'solid',
        radius: style.borderRadius
      };
      target = active;
      // Native focus already reveals controls; this also reveals clipped image
      // cards whose actual link text occupies only a small part of the card.
      var reveal = active.classList.contains('stretched-link') ?
        active.closest('.card, .product-card, .featured_item_card') || active : active;
      reveal.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: 'instant'});
      if (resizeObserver) { resizeObserver.observe(reveal); observed = reveal; }
    }
    var rect = bounds(active);
    var viewport = window.visualViewport;
    var minX = viewport ? viewport.offsetLeft : 0;
    var minY = viewport ? viewport.offsetTop : 0;
    var maxX = minX + (viewport ? viewport.width : document.documentElement.clientWidth);
    var maxY = minY + (viewport ? viewport.height : window.innerHeight);
    if (rect.right <= minX || rect.left >= maxX || rect.bottom <= minY || rect.top >= maxY ||
        rect.right <= rect.left || rect.bottom <= rect.top) {
      if (ring) ring.hidden = true;
      active.removeAttribute('data-pm-focus-overlay');
      return;
    }
    if (!ring) {
      ring = document.createElement('div');
      ring.id = 'pm-keyboard-focus-ring';
      ring.setAttribute('aria-hidden', 'true');
      ring.setAttribute('inert', '');
      // A manual popover escapes clipping and native dialog top layers without
      // moving the focused control or changing the document's stacking order.
      if (typeof ring.showPopover === 'function') ring.setAttribute('popover', 'manual');
      document.body.appendChild(ring);
    }
    var distance = 2 + appearance.width;
    var left = Math.max(minX, rect.left - distance);
    var top = Math.max(minY, rect.top - distance);
    var right = Math.min(maxX, rect.right + distance);
    var bottom = Math.min(maxY, rect.bottom + distance);
    ring.style.left = left + 'px';
    ring.style.top = top + 'px';
    ring.style.width = Math.max(0, right - left) + 'px';
    ring.style.height = Math.max(0, bottom - top) + 'px';
    ring.style.borderWidth = appearance.width + 'px';
    ring.style.borderStyle = appearance.style;
    ring.style.borderColor = forcedColors.matches ? 'Highlight' : appearance.color;
    ring.style.borderRadius = appearance.radius;
    ring.hidden = false;
    if (ring.hasAttribute('popover') && !ring.matches(':popover-open')) ring.showPopover();
    active.setAttribute('data-pm-focus-overlay', '');
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(paint);
  }
  function trackAnimation() {
    animationFrame = null;
    schedule();
    if (target && performance.now() < animationUntil) animationFrame = window.requestAnimationFrame(trackAnimation);
  }
  function followTransition() {
    animationUntil = performance.now() + 650;
    if (!animationFrame) animationFrame = window.requestAnimationFrame(trackAnimation);
  }
  document.addEventListener('keydown', function (event) {
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    keyboard = true;
    schedule();
  }, true);
  document.addEventListener('pointerdown', function () {keyboard = false; clear();}, true);
  document.addEventListener('focusin', function () {schedule(); followTransition();}, true);
  document.addEventListener('focusout', schedule, true);
  document.addEventListener('scroll', schedule, {capture: true, passive: true});
  document.addEventListener('transitionrun', followTransition, true);
  document.addEventListener('transitionend', schedule, true);
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('blur', clear);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, {passive: true});
    window.visualViewport.addEventListener('scroll', schedule, {passive: true});
  }
  forcedColors.addEventListener('change', schedule);
  if (window.ResizeObserver) resizeObserver = new ResizeObserver(schedule);
})();
